// extracted by mini-css-extract-plugin
export default {"inputGroup":"styles_inputGroup__OhIZa","header":"styles_header__pCQ7W","label":"styles_label__SL+2B","forgotLink":"styles_forgotLink__Lqw71"};